import anime from 'animejs';
import classNames from 'classnames';
import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import { updateLoginOrSignUp } from 'actions/login';
import { updateNotificationSettings } from 'actions/notification-settings';
import {
  updateShareVideo,
  updateShareVideoInTrimMode,
  updateShareVideoPassword,
  updateShareVideoShowRemoveModal,
  updateVideoCtaShow,
  updateVideoIframeVisibility,
} from 'actions/shareVideo';
import { showStatusBar } from 'actions/statusBar';
import { ERROR } from 'constants/error-severities';
import {
  ENTERED_TRIM_MODE,
  NEW_ONBOARDING_EXISTING_USER_COMPLETE,
  PUSH_NOTIFICATION_PROMPT_ACCEPTED,
  PUSH_NOTIFICATION_PROMPT_DISMISSED,
  SHARE_MENU_ACTION_OPEN_MENU,
  SHARE_VIDEO_EXTENSION_MODAL_CLICK,
} from 'constants/events';
import {
  EMBED_DIMENSIONS_UPDATE,
  EMBED_INLINE_INSTALL_START,
  EMBED_VIDEO_CORRECT_PASS,
  EMBED_VIDEO_DURATION,
  EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED,
  EXTENSION_CLICKED,
} from 'constants/messages';
import { PUSH_ACTIVATION_SETTINGS } from 'constants/notifications';
import { GOOGLE, SLACK } from 'constants/oAuthKeys';
import { CAM } from 'constants/recordingTypes';
import { LOOM_URI, MY_VIDEOS_PAGE, ROOT_PAGE, WELCOME } from 'constants/routes';
import {
  NEW_ONBOARDING_EXISTING_USER,
  REQUEST_PUSH_PERMISSIONS,
} from 'constants/triggers';
import { fetchGoogleInfoCreator } from 'creators/google';
import { postNotificationSettings } from 'creators/notification-settings';
import {
  fetchShareVideoDownloadUrlCreator,
  fetchVideoCreator,
  subscribeToGif,
  updateVideoNameCreator,
} from 'creators/shareVideo';
import { completeTriggerCreator } from 'creators/triggers';
import { enterTrimModeCreator } from 'creators/trimming';
import { postVerifyEmail } from 'creators/user';
import { sendInactiveVideoOwnerPing } from 'creators/videoPlayer';
import * as analytics from 'utilities/analytics';
import * as clipboard from 'utilities/clipboard';
import * as device from 'utilities/device';
import * as extension from 'utilities/extension';
import * as jqueryExt from 'utilities/jqueryExt';
import { getParam, goToNewTab } from 'utilities/url';

import { selectUserCanEditVideo } from 'selectors/shareVideo';

import MobileAppCard from './mobile-app-card';
import ProcessErrorModal from './process-error-modal';
import LoomBadge from '../loom-badge';
import SignupOverlay from '../signup-test/signup-overlay';
import {
  getCustomBrandLogo,
  getLoomBrandVisibility,
} from '../../utilities/custom-branding';
import { TEAM_ACCOUNT_TYPES } from '../../../../shared/constants/accountTypes';
import { END_OF_VIDEO_CTA } from '../../../../shared/constants/capabilities';
import { SHOW_MOBILE_APP_CARD } from '../../../../shared/constants/featureFlag';

import AccountSettingsUpgrade from 'components/account-settings/account-settings-upgrade';
import ConfirmationModal from 'components/confirmation-modal';
import PushNotifDialogPrompt from 'components/dialog-prompt';
import ErrorBar from 'components/error-bar';
import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import InactiveVideoUpgradeModal from 'components/inactive-video-upgrade-modal';
import InviteModal from 'components/invite-modal';
import Layout from 'components/layout';
import NotificationBlockedPrompt from 'components/notification-blocked-prompt';
import TitleBar from 'components/share-page-common/title-bar';
import AttachmentUploadProgressModal from 'components/share-video/attachment-upload-progress-modal';
import AttachmentsBar from 'components/share-video/attachments-bar';
import Comments from 'components/share-video/comments';
import ShareVideoControlBar from 'components/share-video/control-bar';
import CustomCtaButton from 'components/share-video/cta-button';
import CtaModal from 'components/share-video/cta-modal';
import DownloadButton from 'components/share-video/download-button';
import DuplicateButton from 'components/share-video/duplicate-button';
import EditorWidget from 'components/share-video/editor-widget';
import FeatureTour from 'components/share-video/feature-tour';
import FirstVideoModal from 'components/share-video/first-video-modal';
import MoveModal from 'components/share-video/move-modal';
import OwnerInfo from 'components/share-video/owner-info';
import RightPanel from 'components/share-video/right-panel';
import ShareDropdownMenu from 'components/share-video/share-dropdown-menu';
import ShareVideoWidget from 'components/share-video/share-video-widget';
import ThumbnailCropper from 'components/share-video/thumbnail-cropper';
import TrashButton from 'components/share-video/trash-button';
import TrimFooter from 'components/share-video/trim-footer';
import VideoRemoveModal from 'components/share-video/video-remove-modal';
import VideoReplyParentIndicator from 'components/share-video/video-reply-parent-indicator';
import StatusBar from 'components/status-bar';
import Button from 'components/ui-components/button';
import CreateHintTooltip from 'components/ui-components/create-hint-tooltip';
import ErrorBoundary from 'components/ui-components/error-boundary';
import Modal from 'components/ui-components/modal';
import Tooltip from 'components/ui-components/tooltip';
import VideoFrame from 'components/video-frame';
import PermissionModal from 'components/video-player/permission-modal';
import MoveModalTA from 'components/videos-dashboard-ta/move-modal';
import ViewerList from 'components/viewer-list';

import './styles.less';

// added to the document body of the share page to fade everything to black
const TRIM_MODE_CLASS = 'trim-mode-enabled';

// analytics event for notification dialog upselling
const SHARE_VIDEO_PAGE_TITLE = 'Share Video';

// status bar class (bg dark color) for notification dialog upselling
const HAS_STATUS_BAR_CLASS = 'has-status-bar';

const IS_IOS_MOBILE = device.isMobile && device.isIOS;

const InactiveVideoContactOwnerModal = props => {
  const { show, name, pingOwner, ownerPinged, goToLoom } = props;

  const notPingedContent = (
    <Fragment>
      <div className="share-video-inactive-video-contact-modal-title">
        This video is currently inactive.
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        {`We'll let ${name ||
          'the owner'} know you'd like to watch their video.`}
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          onClicked={pingOwner}
          buttonType="rp-primary-2"
          value="Yes! Let them know."
        />
      </div>
    </Fragment>
  );

  const pingedContent = (
    <Fragment>
      <div className="share-video-inactive-video-contact-modal-title">
        Thanks!
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        Your request is on its way! 🚀
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          capitalize={false}
          onClicked={goToLoom}
          buttonType="rp-primary-2"
          value="Go to loom.com"
        />
      </div>
    </Fragment>
  );

  return (
    <div className="share-video-inactive-video-contact-modal">
      <Modal show={show} dark={true} showClose={false}>
        {ownerPinged ? pingedContent : notPingedContent}
      </Modal>
    </div>
  );
};

class ShareVideo extends Component {
  static shareMethodsClassName = 'share-methods';

  state = {
    show_upgrade_modal: false,
    show_create_recording_tooltip: false,
    show_ext_install_bubb: false,
    show_signup_modal: false,
    show_share_dropdown: false,
    startTimeParam: getParam('t'),
    video_id: window.location.pathname.replace('/share/', ''),
    ownerPinged: false,
    mobileAppCardIsVisible: true,
  };

  render() {
    const {
      video_id: videoId,
      show_share_dropdown,
      show_upgrade_modal: showUpgradeModal,
      show_create_recording_tooltip: showCreateRecordingTooltip,
      show_signup_modal: showSignupModal,
      startTimeParam,
    } = this.state;

    const {
      ctaEnabled,
      currentUserIsOwner,
      downloadUrl,
      errorBarShown,
      fetchingVideo,
      focusTitle,
      iframeLoaded,
      inTrimMode,
      isLoggedIn,
      isLoggedInChecked,
      isTeamAccount,
      needsPermission,
      playerReady,
      showCtaModal,
      showMoveModal,
      showRemoveModal,
      slackTeammates,
      showThumbnailCropper,
      showUploadAttachmentProgressModal,
      theaterMode,
      useEmojis,
      user,
      userCanEdit,
      video,
      videoIsSharedWithUser,
      videoIsTeamShared,
    } = this.props;

    const { video_properties: videoProperties, parentVideoProperties } = video;
    const { isVideoReply } = videoProperties;
    const showViewerList =
      isLoggedInChecked &&
      !video.videoAnalyticsEnabled &&
      (currentUserIsOwner || videoIsTeamShared || videoIsSharedWithUser);

    // we always prioritize slack over google for people that have both oauth'd
    const inviteProvider = slackTeammates.length > 0 ? SLACK : GOOGLE;

    const downloadName = `${video.name || video.id}.mp4`;
    const ownerVerified = video.owner_verified;

    const companyFeatureData = video.company_feature_data || null;

    return (
      <Layout
        hasOverlayNavBar
        companyFeatureData={companyFeatureData}
        useLegacyNavigation={!isTeamAccount}
      >
        <ErrorBar />
        <FirstVideoModal />
        {!isLoggedIn && (
          <SignupOverlay
            afterAuthCallback={() => window.location.reload()}
            show={showSignupModal}
            onDismiss={this.handleAccountOverlayClose}
          />
        )}
        {currentUserIsOwner && <FeatureTour />}
        <ErrorBoundary>
          <div
            className={classNames('share-video-container', {
              'current-user-is-owner': currentUserIsOwner,
              'error-bar-shown': errorBarShown,
              'theater-mode': theaterMode,
            })}
          >
            <div
              className={classNames('theater-player-container', {
                'theater-mode': theaterMode,
                'use-emojis': useEmojis,
              })}
            />
            <div
              className={classNames('left-panel', {
                'is-cam': video.video_properties.screen_type === CAM,
                'use-emojis': useEmojis,
              })}
            >
              <VideoFrame videoId={videoId} startTime={startTimeParam}>
                {showCtaModal && <CtaModal />}
                {!device.isMobile && (useEmojis || inTrimMode) && (
                  <ShareVideoControlBar
                    duration={video.video_properties.duration}
                    hasGmailAccount={user.has_gmail_account}
                    isLoggedIn={isLoggedIn}
                    isProtected={video.is_protected}
                    onLeaveTrimMode={this.handleLeaveTrimMode}
                    playerReady={playerReady}
                    video={video}
                  />
                )}
                {showThumbnailCropper && (
                  <ThumbnailCropper videoId={video.id} />
                )}
              </VideoFrame>
              {inTrimMode && (
                <TrimFooter
                  onRevertClicked={this.handleLeaveTrimMode}
                  video={video}
                />
              )}
              <div className="video-metadata-slideable">
                <div className="below-video">
                  <div className="share-video-title-tools">
                    <TitleBar
                      userCanEdit={userCanEdit}
                      shouldFocusTitle={currentUserIsOwner && focusTitle}
                      video={video}
                      onTitleUpdate={this.props.updateVideoNameCreator}
                    />
                    <div className="share-video-tools">
                      <DownloadButton
                        postVerifyEmail={this.props.postVerifyEmail}
                        currentUserIsOwner={currentUserIsOwner}
                        downloadEnabled={video.download_enabled}
                        downloadName={downloadName}
                        downloadUrl={downloadUrl}
                        onDownloadUnverifiedClicked={
                          this.handleDownloadUnverifiedClicked
                        }
                        handleAccountOverlayOpen={this.handleAccountOverlayOpen}
                        ownerVerified={ownerVerified}
                        useBorder={false}
                        videoId={video.id}
                        videoIsTeamShared={videoIsTeamShared}
                        isLoggedIn={isLoggedIn}
                      />
                      {(currentUserIsOwner || videoIsTeamShared) && (
                        <DuplicateButton video={video} />
                      )}
                      {(currentUserIsOwner ||
                        videoIsTeamShared ||
                        video.collaboratePermissions.delete) && (
                        <TrashButton onClick={this.handleDeleteButtonClicked} />
                      )}
                      <div
                        className="round-button round-button-share ignore-react-onclickoutside-share"
                        onClick={this.toggleShareDropdown}
                      >
                        <Tooltip>Share</Tooltip>
                        <ShareDropdownMenu
                          align="right"
                          vAlign="auto"
                          isLoggedIn={isLoggedIn}
                          outsideClickIgnoreClass="ignore-react-onclickoutside-share"
                          onHide={this.hideShareDropdown}
                          show={show_share_dropdown}
                          currentUserIsOwner={currentUserIsOwner}
                          hasGmailAccount={user.has_gmail_account}
                          video={video}
                        />
                      </div>
                    </div>
                  </div>
                  <OwnerInfo
                    currentUserIsOwner={currentUserIsOwner}
                    videoIsTeamShared={videoIsTeamShared}
                    videoIsSharedWithUser={videoIsSharedWithUser}
                    video={video}
                  />
                  <div className="mobile-actions">
                    <div className="share-wrapper">
                      <div
                        className="mobile-actions-share ignore-react-onclickoutside-share"
                        onClick={this.toggleShareDropdown}
                      >
                        <ShareDropdownMenu
                          align="center"
                          vAlign="auto"
                          isLoggedIn={isLoggedIn}
                          outsideClickIgnoreClass="ignore-react-onclickoutside-share"
                          onHide={this.hideShareDropdown}
                          show={show_share_dropdown}
                          currentUserIsOwner={currentUserIsOwner}
                          hasGmailAccount={user.has_gmail_account}
                          video={video}
                        />
                        <span>Share</span>
                      </div>
                      <div
                        className="mobile-actions-link"
                        onClick={this.handleClickCopyLink}
                      >
                        <div className="mobile-actions-link-success">
                          Link copied to clipboard!
                        </div>
                        Copy Link
                        <input
                          ref={ref => (this.copyLinkInput = ref)}
                          readOnly
                          value={`${LOOM_URI}/share/${video.id}`}
                        />
                      </div>
                    </div>
                    {ctaEnabled && <CustomCtaButton />}
                  </div>
                </div>
                {isVideoReply && (
                  <VideoReplyParentIndicator
                    parentProperties={parentVideoProperties}
                  />
                )}
                {userCanEdit && (
                  <div className="tablet-actions">
                    <EditorWidget
                      showUpgradeModal={this.showUpgradeModal}
                      onEnterTrimMode={this.handleEnterTrimMode}
                      video={video}
                    />
                    <ShareVideoWidget
                      showUpgradeModal={this.showUpgradeModal}
                      className={ShareVideo.shareMethodsClassName}
                      video={video}
                    />
                  </div>
                )}
                {!currentUserIsOwner && <AttachmentsBar />}
                {showViewerList && (
                  <ViewerList inviteProvider={inviteProvider} />
                )}
                {(currentUserIsOwner ||
                  videoIsTeamShared ||
                  videoIsSharedWithUser ||
                  video.comments_enabled) && (
                  <Comments iframeLoaded={iframeLoaded} />
                )}
              </div>
              <ConfirmationModal />
              {isTeamAccount ? (
                <MoveModalTA isOpen={showMoveModal} isSharePage={true} />
              ) : (
                <MoveModal />
              )}
            </div>
            {userCanEdit && (
              <RightPanel
                showUpgradeModal={this.showUpgradeModal}
                onEnterTrimMode={this.handleEnterTrimMode}
                theaterMode={theaterMode}
                userCanEdit={userCanEdit}
              />
            )}
            {isLoggedIn && (
              <Fragment>
                <PushNotifDialogPrompt
                  onAction={this.handleNotificationDialogPromptAction}
                  onClose={this.handleNotificationDialogPromptClose}
                />
                <StatusBar
                  onAction={this.handleNotificationStatusBarAction}
                  onClose={this.handleNotificationStatusBarClose}
                />
                <NotificationBlockedPrompt />
              </Fragment>
            )}
            {showRemoveModal && (
              <VideoRemoveModal
                videoId={videoId}
                onCloseModal={this.handleLeaveRemoveModal}
              />
            )}
          </div>
          {showCreateRecordingTooltip && (
            <CreateHintTooltip
              onClose={() => {
                this.setState({ show_create_recording_tooltip: false });
              }}
            />
          )}
          <InviteModal />
          <ProcessErrorModal />
          <InactiveVideoContactOwnerModal
            goToLoom={this.goToLoom}
            pingOwner={this.pingOwner}
            ownerPinged={this.state.ownerPinged}
            name={video.owner_name}
            show={!currentUserIsOwner && !video.active_status}
          />
          {!showUpgradeModal && (
            <InactiveVideoUpgradeModal
              onUpgradeClick={this.showUpgradeModal}
              onClose={this.goToDashboard}
              show={currentUserIsOwner && !video.active_status}
            />
          )}
          {showUpgradeModal && (
            <AccountSettingsUpgrade onClose={this.hideUpgradeModal} />
          )}
          {!fetchingVideo && needsPermission && <PermissionModal />}
          {showUploadAttachmentProgressModal && (
            <AttachmentUploadProgressModal />
          )}
          <div id="gmail-integration-share-page-placeholder" />
        </ErrorBoundary>
        {getLoomBrandVisibility() && getCustomBrandLogo() && (
          <div className="share-video-loom-badge-section">
            <LoomBadge href="https://www.loom.com" title="Loom homepage" />
          </div>
        )}

        {IS_IOS_MOBILE && this.state.mobileAppCardIsVisible && (
          <FeatureFlaggedComponent
            flag={SHOW_MOBILE_APP_CARD}
            activationValue={true}
          >
            <MobileAppCard onCloseClick={this.handleMobileAppCardClose} />
          </FeatureFlaggedComponent>
        )}
      </Layout>
    );
  }

  async componentDidMount() {
    window.addEventListener('message', this.handleShareVideoEvents);

    const {
      user = {},
      video = {},
      currentUserIsOwner,
      theaterMode,
    } = this.props;

    if (theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (video.complete) {
      this.props.updateVideoIframeVisibility();
      this.props.fetchShareVideoDownloadUrlCreator();
    }

    this.props.subscribeGifReady(video.id);

    // once the user oauth has been fetched we fetch the google contact info
    // but in case the user already has named video views we don't need to fetch
    // this info since we only require it when we need to invite. In which case
    // the fetch happens when the invite modal pops up.
    if (user.oauth && !user.has_named_video_views) {
      this.props.fetchGoogleInfoCreator();
    }

    if (user.capabilities[END_OF_VIDEO_CTA] === true) {
      this.props.updateVideoCtaShow(true);
    }

    const installed = await new Promise(resolve => {
      extension.isInstalled(resolve);
    });

    if (
      !installed &&
      (extension.canRunExtension || (!device.isMobile && !device.isChrome))
    ) {
      this.setState({
        show_ext_install_bubb: true,
      });
    }

    const { isLoggedIn } = this.props;

    analytics.page('Individual Video', {
      url: null,
      is_owner: Boolean(currentUserIsOwner),
      is_logged_in: isLoggedIn,
    });

    this.setState({
      startTimeParam: getParam('t'),
    });
  }

  componentDidUpdate(prevProps) {
    const { inTrimMode, theaterMode } = this.props;

    // This is the quickest and smoothest way to move a video to a different element
    // and not cause any jiterryness
    if (!prevProps.theaterMode && theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (prevProps.theaterMode && !theaterMode) {
      this.removePlayerFromTheaterElement();
    }

    if (inTrimMode != prevProps.inTrimMode) {
      const rootElement = document.documentElement;

      rootElement.className = rootElement.className.replace(
        TRIM_MODE_CLASS,
        ''
      );

      if (inTrimMode) {
        rootElement.className += ` ${TRIM_MODE_CLASS}`;
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleShareVideoEvents);
  }

  attachPlayerToTheaterElement = () => {
    const theaterPlayerContainer = document.querySelector(
      '.theater-player-container'
    );

    theaterPlayerContainer.appendChild(
      document.querySelector('.embed-video-frame-wrapper')
    );

    // TODO: Convert to react functional component and use react hook
    // to trigger getResponsiveVideoWrapperDimensions
    // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
    // @paulius005
    this.forceUpdate();
  };

  removePlayerFromTheaterElement = () => {
    const leftPanel = document.querySelector('.left-panel');

    leftPanel.insertBefore(
      document.querySelector('.embed-video-frame-wrapper'),
      leftPanel.firstChild
    );

    // TODO: Convert to react functional component and use react hook
    // to trigger getResponsiveVideoWrapperDimensions
    // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
    // @paulius005
    this.forceUpdate();
  };

  pingOwner = () => {
    this.props.sendInactiveVideoOwnerPing();

    this.setState({ ownerPinged: true });
  };

  showUpgradeModal = () => this.setState({ show_upgrade_modal: true });
  hideUpgradeModal = () => this.setState({ show_upgrade_modal: false });

  goToDashboard = () => (window.location.pathname = MY_VIDEOS_PAGE);
  goToLoom = () => (window.location.pathname = ROOT_PAGE);

  handleInstallModalButtonClick = () => {
    const {
      video: { id: videoId },
    } = this.props;

    analytics.track(SHARE_VIDEO_EXTENSION_MODAL_CLICK, {
      video_id: videoId,
    });
  };

  handleAccountOverlayClose = () => {
    this.setState({ show_signup_modal: false });
  };

  handleAccountOverlayOpen = () => {
    this.setState({ show_signup_modal: true });
  };

  handleExtensionInstalled = () => {
    const { isLoggedIn } = this.props;

    this.setState({ show_ext_install_bubb: false });

    if (!isLoggedIn) {
      this.props.updateLoginOrSignUp(false);

      return this.setState({ show_signup_modal: true });
    }

    if (!extension.canRunExtension) {
      return;
    }

    this.setState({ show_create_recording_tooltip: true });
  };

  handleExtensionInstallError = message => {
    const { isLoggedIn } = this.props;

    this.props.showErrorBar(ERROR, message);

    // if they can't install the extension for some reason, still try to get
    // them to sign up
    if (!isLoggedIn) {
      this.props.updateLoginOrSignUp(false);
      this.setState({ show_signup_modal: true });
    }
  };

  handleDeleteButtonClicked = () => {
    this.props.updateShareVideoShowRemoveModal(true);
  };

  handleLeaveRemoveModal = () => {
    this.props.updateShareVideoShowRemoveModal(false);
  };

  handleEnterTrimMode = () => {
    const {
      id: videoId,
      processing_information: { trim_ranges: trimRanges = [] },
    } = this.props.video;

    this.props.enterTrimModeCreator(trimRanges);

    this.props.updateShareVideoInTrimMode(true);

    analytics.track(ENTERED_TRIM_MODE, {
      id: videoId,
      has_been_trimmed: trimRanges.length > 0,
    });
  };

  handleLeaveTrimMode = () => {
    this.props.updateShareVideoInTrimMode(false);
  };

  handleDownloadUnverifiedClicked = e => {
    e.preventDefault();

    if (!this.props.video.owner_verified) {
      const subject = this.props.currentUserIsOwner ? 'you' : 'the sender';
      const reference = this.props.currentUserIsOwner ? 'your' : 'their';

      window.alert(
        'In order to download this video, ' +
          subject +
          ' must verify ' +
          reference +
          ' email.'
      );
    }

    return false;
  };

  handleNotificationDialogPromptAction = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [REQUEST_PUSH_PERMISSIONS]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(PUSH_NOTIFICATION_PROMPT_ACCEPTED);

      this.props.updateNotificationSettings(PUSH_ACTIVATION_SETTINGS);
      this.props.postNotificationSettings(PUSH_ACTIVATION_SETTINGS);
    }
  };

  handleNotificationDialogPromptClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [REQUEST_PUSH_PERMISSIONS]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(PUSH_NOTIFICATION_PROMPT_DISMISSED);

      this.props.completeTriggerCreator(REQUEST_PUSH_PERMISSIONS);
    }
  };

  handleNotificationStatusBarAction = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: true,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });

      goToNewTab(`${LOOM_URI}${WELCOME}`);
    }
  };

  handleNotificationStatusBarClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: false,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });
    }
  };

  toggleShareDropdown = () => {
    // If currently closed, it will now open, so track it
    if (!this.state.show_share_dropdown) {
      analytics.track(SHARE_MENU_ACTION_OPEN_MENU);
    }

    this.setState({ show_share_dropdown: !this.state.show_share_dropdown });
  };

  hideShareDropdown = () => {
    this.setState({ show_share_dropdown: false });
  };

  handleClickCopyLink = () => {
    anime
      .timeline({
        targets: '.mobile-actions-link-success',
        easing: 'easeInOutQuad',
        duration: 250,
      })
      .add({
        opacity: [0, 1],
      })
      .add({
        delay: 2500,
        opacity: [1, 0],
      });

    clipboard.selectNodeText(this.copyLinkInput);

    const didCopy = clipboard.copy(this.copyLinkInput);

    if (this.props.onClick) {
      this.props.onClick(didCopy);
    }
  };

  handleShareVideoEvents = e => {
    const origin =
      e.origin || (e.originalEvent && e.originalEvent.origin) || '';
    const data = e.data || (e.originalEvent && e.originalEvent.data) || {};

    if (origin.indexOf(LOOM_URI) < 0) {
      return;
    }

    switch (data.type) {
      case EMBED_DIMENSIONS_UPDATE:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            height: data.height,
            width: data.width,
          },
        });
        break;
      case EMBED_INLINE_INSTALL_START:
        this.inlineInstall(data.source);
        break;
      case EMBED_VIDEO_CORRECT_PASS:
        this.props.updateShareVideoPassword(data.password);
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EMBED_VIDEO_DURATION:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            duration: data.duration,
          },
        });
        break;
      case EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED:
        this.props.updateShareVideo({
          ...this.props.video,
          processing_information: data.processing_information,
        });
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EXTENSION_CLICKED:
        this.setState({ show_create_recording_tooltip: false });
        break;
      default:
    }
  };

  handleMobileAppCardClose = () => {
    this.setState({ mobileAppCardIsVisible: false });
  };

  async inlineInstall(source) {
    if (!extension.canRunExtension) {
      return this.handleExtensionInstalled();
    }

    const installed = await new Promise(resolve => {
      extension.isInstalled(resolve);
    });

    if (installed) {
      return this.handleExtensionInstalled();
    }

    extension.inlineInstall(source, () => {
      this.handleExtensionInstalled();
    });
  }
}

const mapStateToProps = state => {
  const {
    current_user_is_owner: currentUserIsOwner,
    download_url: downloadUrl,
    iframe_loaded: iframeLoaded,
    player_ready: playerReady,
    show_remove_modal: showRemoveModal,
    cta_enabled: ctaEnabled,
    video,
    video_is_team_shared: videoIsTeamShared,
  } = state.share_video;

  const {
    is_logged_in: isLoggedIn,
    is_logged_in_checked: isLoggedInChecked,
    current,
  } = state.user;

  const {
    show_invite_modal: showSlackInviteModal,
    team_info: teamInfo,
  } = state.slack;

  const { showUploadAttachmentProgressModal } = state.attachments;

  const slackTeammates = (teamInfo || {}).people || [];

  const { triggers } = state.triggers;

  const { in_trim_mode: inTrimMode } = state.trimming;

  const { showing: errorBarShown } = state.error_bar;

  const { dm_content = [] } = state.multi_share;

  const { cta_flow, thumbnail_flow } = state.editor;

  const {
    is_fetching: fetchingVideo,
    viewer_needs_permission: needsPermission,
    theater_mode: theaterMode,
  } = state.video_player;

  const { showMoveModal } = state.moveModal;

  const videoIsSharedWithUser =
    Object.keys(video.collaboratePermissions).length > 0;
  const isTeamAccount = TEAM_ACCOUNT_TYPES.includes(current.account_type);

  return {
    currentUserIsOwner,
    ctaEnabled,
    dm_content,
    downloadUrl,
    errorBarShown,
    fetchingVideo,
    iframeLoaded,
    inTrimMode,
    isLoggedIn,
    isLoggedInChecked,
    isTeamAccount,
    needsPermission,
    playerReady,
    showCtaModal: cta_flow,
    showMoveModal,
    showRemoveModal,
    showSlackInviteModal,
    showThumbnailCropper: thumbnail_flow,
    slackTeammates,
    theaterMode,
    showUploadAttachmentProgressModal,
    triggers,
    user: current,
    useEmojis: video.use_emojis,
    userCanEdit: selectUserCanEditVideo(state),
    video,
    videoIsSharedWithUser,
    videoIsTeamShared,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    postVerifyEmail: () => dispatch(postVerifyEmail()),
    enterTrimModeCreator: trimRanges =>
      dispatch(enterTrimModeCreator(trimRanges)),
    completeTriggerCreator: trigger =>
      dispatch(completeTriggerCreator(trigger)),
    fetchGoogleInfoCreator: () => dispatch(fetchGoogleInfoCreator()),
    fetchShareVideoDownloadUrlCreator: () =>
      dispatch(fetchShareVideoDownloadUrlCreator()),
    fetchVideoCreator: videoId => dispatch(fetchVideoCreator(videoId)),
    postNotificationSettings: notificationSettings =>
      dispatch(
        postNotificationSettings(
          notificationSettings,
          'Re-enabled From Video Page'
        )
      ),
    showErrorBar: (severity, message) =>
      dispatch(showErrorBar(severity, message)),
    showStatusBar: statusBarParams => dispatch(showStatusBar(statusBarParams)),
    updateLoginOrSignUp: logIn => dispatch(updateLoginOrSignUp(logIn)),
    updateNotificationSettings: notificationSettings =>
      dispatch(updateNotificationSettings(notificationSettings)),
    updateShareVideo: video => dispatch(updateShareVideo(video)),
    updateShareVideoInTrimMode: inTrimMode =>
      dispatch(updateShareVideoInTrimMode(inTrimMode)),
    updateShareVideoPassword: password =>
      dispatch(updateShareVideoPassword(password)),
    updateShareVideoShowRemoveModal: show =>
      dispatch(updateShareVideoShowRemoveModal(show)),
    updateVideoCtaShow: show => dispatch(updateVideoCtaShow(show)),
    updateVideoNameCreator: name => dispatch(updateVideoNameCreator(name)),
    sendInactiveVideoOwnerPing: () => dispatch(sendInactiveVideoOwnerPing()),
    updateVideoIframeVisibility: isVisible =>
      dispatch(updateVideoIframeVisibility(isVisible)),
    subscribeGifReady: id => dispatch(subscribeToGif(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareVideo);
